<template lang="html">
  <div id="home-page">

    <!-- Banners -->
    <section class="banner-section">
      <swiper class="swiper d-none d-lg-block" :options="bannersOptions">
        <swiper-slide v-for="(bd, bdInx) in banners.desktop" :key="'bdInx-'+bdInx">
          <a :href="bd.url">
            <img class="placed-backg d-lg-block" src="public/images/pages/home/banner.png" v-bind:style="{ backgroundImage: 'url('+bd.image+')' }">
          </a>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <swiper class="swiper d-lg-none" :options="bannersOptions">
        <swiper-slide v-for="(bm, bmInx) in banners.mobile" :key="'bmInx-'+bmInx">
          <a :href="bm.url">
            <img class="placed-backg d-lg-block" src="public/images/pages/home/banner-m.png" v-bind:style="{ backgroundImage: 'url('+bm.image+')' }">
          </a>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </section>
    <!--  -->

    <!-- Categories -->
    <!-- <section class="categories-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-md-6 col-lg-4 col-category" v-for="(c, cInx) in categories" :key="'cInx-'+cInx">
            <router-link class="box-category-s1" to="/producto/5">
              <img src="public/images/shared/empty.png">
              <div class="placed-backg t-150 img" v-bind:style="{ backgroundImage : 'url('+c.imageUrl+')' }"></div>
              <div class="b-text">
                <div class="inside">
                  <h5>{{ c.name }}</h5>
                </div>
              </div>

              <div class="b-description-con">
                <div class="inside-descr">
                  <div>
                    <h4 class="title">{{ c.name }}</h4>

                    <p>
                      {{ c.descr }}
                    </p>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section> -->
    <!--  -->

    <!-- Productos -->
    <section class="products-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <!-- <h2 class="title-s1">PRODUCTOS DESTACADOS</h2> -->
            <h2 class="title-s1">ÚLTIMOS PRODUCTOS</h2>
          </div>

          <div class="col-12 col-products">
            <swiper class="swiper carousel-t1" :options="productsOption">
              <swiper-slide v-for="(product, pInx) in products" :key="'pInx-'+pInx">
                <div class="col-12 px-0 sample-product shad-prod">
                  <a class="outlined-box">
                    <router-link class="fake-link" :to="'/producto/'+$root._converToURL(product.name, product.id)"></router-link>

                    <div class="box-image">
                      <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                      <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.image+')' }">
                        <img src="public/images/pages/products/product.png" >
                      </div>
                    </div>

                    <div class="box-shot-descr">
                      <h6 class="brand">{{ product.sku }}</h6>
                      <h6 class="name">{{ product.name }}</h6>
                      <div class="b-type" v-if="product.stock">
                        <div class="type s2">{{ product.stock }} DISPONIBLES</div>
                      </div>
                      <!-- <h6 class="brand">{{ product.brand }}</h6> -->
                      <!-- <h6 class="price discount"><span>$ {{ product.price }}</span></h6> -->
                      <h6 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} USD</h6>
                    </div>

                    <cart-component :product="product"></cart-component>
                  </a>
                </div>
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <ExperienceComponent></ExperienceComponent>

    <!-- Ocasiones -->
    <section class="occasion-section" v-if="false">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">BUSQUEDA POR OCASIONES</h2>
          </div>

          <div class="col-12 col-carousel">
            <swiper class="swiper" :options="occasionsOptions">
              <swiper-slide v-for="(c, chInx) in occasions" :key="'chInx-'+chInx">
                <div class="col-12 px-0 box-occasion-s1" >
                  <router-link class="box-link" to="/productos/1">
                    <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+c.imageUrl+')' }">
                      <img src="public/images/shared/empty.png">
                    </div>

                    <div class="box-info">
                      <h5 class="title">{{ c.title }}</h5>

                      <!-- <h5 class="price">PRECIOS DESDE: ${{ c.price }}</h5> -->
                    </div>
                  </router-link>
                </div>
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Blog -->
    <section class="blog-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">BLOG</h2>
          </div>

          <div class="col-12">
            <swiper class="swiper swiper-st-2" :options="blogOptions">
              <swiper-slide v-for="(ah, ahInx) in blog" :key="'ahInx-'+ahInx">
                <div class="col-12 px-0 box-article-s1">
                  <router-link class="box" :to="'/blog/'+ah.id">
                    <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+ah.image+')' }"></div>

                    <div class="box-info">
                      <h5 class="title">{{ ah.name }}</h5>

                      <div class="b-text" v-html="ah.body"></div>
                    </div>
                  </router-link>
                </div>
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Brands -->
    <section class="container oversized-container brands-section" v-if="false">
      <div class="row">
        <div class="col-12 col-sm-title">
          <h2 class="title-s1">ALGUNOS DE NUESTROS CLIENTES</h2>
        </div>

        <div class="col-12 col-brands">
          <swiper class="swiper" :options="brandsOptions">
            <swiper-slide v-for="(brand, brhInx) in brands" :key="'brhInx-'+brhInx">
              <div class="box-brand">
                <!-- <router-link to=""> -->
                <a :href="brand.link">
                  <div class="inside">
                    <img :src="brand.imageUrl">
                  </div>
                </a>
                <!-- </router-link> -->
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>
    <!--  -->

    <loading-bg-component v-if="isLoading"></loading-bg-component>

  </div>
</template>

<script>
import ExperienceComponent from './company/experience-component.vue';
export default {
  components: {
    ExperienceComponent
  },

  data() {
    return {
      isLoading: true,

      banners: {
        desktop: [
          { imageUrl: 'public/images/pages/home/banner.png' },
        ],
        mobile: [
          { imageUrl: 'public/images/pages/home/banner-m.png' },
        ],
      },

      categories: [
        { imageUrl: 'public/images/pages/products/category-1.jpg', name: 'Luvistrap ®', descr: `El Fleje Luvistrap® Es una banda plástica extruida de polipropileno (PP) conocido como fleje de plástico se utiliza para asegurar pallets, carga de grandes dimensiones ó agrupar los productos.` },
        { imageUrl: 'public/images/pages/products/category-2.jpg', name: 'Luvitape ®', descr: `La cinta de empaque: Conocida como cinta canela o cinta transparente, es ideal para el cerrado de cajas y bolsas de plástico, por lo que los usuarios van desde las grandes industrias hasta el mercado detallista.` },
        { imageUrl: 'public/images/pages/products/category-3.jpg', name: 'Luviburbu ®', descr: `El Luviburbu® es el conjunto de dos películas de polietileno que encapsulan aire formando una “burbuja” para así proteger de golpes, vibración y movimientos de diversos productos.` },
        { imageUrl: 'public/images/pages/products/category-4.jpg', name: 'Luvifoam ®', descr: `El Luvifoam® también conocido como Poly Pack es un material laminado de espuma de polietileno que proporciona una excelente protección a productos ligeros. Es sumamente flexible.` },
        { imageUrl: 'public/images/pages/products/category-5.jpg', name: 'Luvistretch ®', descr: `Luvistretch® también conocida como Película estirable, es una película Co-Extruida en Polietileno, la cual se utiliza en el Atado y Flejado de Tarimas, Muebles, además de tener otras aplicaciones en el embalaje de productos.` },
        { imageUrl: 'public/images/pages/products/category-6.jpg', name: 'Nueva Luvi Era®', descr: `Mas de 200% de elongacion. Proceso formulado de manera única, el cual, evita que la película pre estirada pierda propiedades, como el efecto de contraer y asegurar la carga, dando así la contención más alta.` },
      ],

      products: [
        // {
        //   "id": 1,
        //   "sku": "63423",
        //   "name": "CORONA T-358 PLATA",
        //   "price": "75.00",
        //   "stock": 1,
        //   "imageUrl": "public/images/pages/products/product-1.jpg"
        // },
      ],

      brands: [
        { link: null, imageUrl: 'public/images/pages/home/brand-1.png' },
        { link: null, imageUrl: 'public/images/pages/home/brand-2.png' },
        { link: null, imageUrl: 'public/images/pages/home/brand-3.png' },
        { link: null, imageUrl: 'public/images/pages/home/brand-4.png' },
      ],

      occasions: [
        { imageUrl: 'public/images/pages/products/occasion-1.jpg', title: 'Para XV Años' },
        { imageUrl: 'public/images/pages/products/occasion-2.jpg', title: 'Para Bodas' },
        { imageUrl: 'public/images/pages/products/occasion-3.jpg', title: 'Para Bautizos' },
        { imageUrl: 'public/images/pages/products/occasion-4.jpg', title: 'Para Confirmación' },
      ],

      blog: [
        // { imageUrl: 'public/images/pages/blog/article-1.jpg',
        //   title: 'Ideas creativas que sorprenderán a todos: decoración y canciones',
        //   text: `
        //     Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        //   `
        // },
      ],

      // == Carousel options ==
      bannersOptions: {
        loop: true,
        speed: 700,
        effect: 'fade',

        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },

      brandsOptions: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 20,

        autoplay: {
          delay: 4500,
          disableOnInteraction: false
        },

        breakpoints: {
          1200: {
            slidesPerView: 4,

            autoplay: {
              delay: 40500,
              disableOnInteraction: false
            },
          },
          768: {
            slidesPerView: 3,

            autoplay: {
              delay: 4500,
              disableOnInteraction: false
            },
          },
          0: {
            slidesPerView: 1,
          },
        }
      },

      blogOptions: {
        slidesPerView: 2,
        spaceBetween: 30,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        }
      },

      productsOption: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 4,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1200: {
            spaceBetween: 0,
            slidesPerView: 4
          },
          992: {
            spaceBetween: 0,
            slidesPerView: 3
          },
          768: {
            spaceBetween: 0,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        effect: 'slide',
        speed: 600
      },

      occasionsOptions: {
        slidesPerView: 3,
        spaceBetween: 30,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1660: {
            slidesPerView: 4,
            spaceBetween: 30
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 0
          },
        }
      },
      // == ==
    }
  },

  methods: {
    getBanners() {
      axios.post(tools.url('/api/banners')).then((response) =>{
        this.banners = response.data;
        // this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },

    getLastProducts() {
      axios.post(tools.url('/api/products/last')).then((response) =>{
        this.products = response.data;
        // this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },

    getBlog() {
      axios.post(tools.url('/api/blog')).then((response) =>{
        this.blog = response.data;
        this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },
  },

  beforeMount() {
    this.getBanners();
    this.getLastProducts();
    this.getBlog();
  },
}
</script>
